import React, { useReducer, useContext, useCallback } from "react"
import { Commands } from 'shared/resources/BitbiteCommands';
import { SessionContext } from 'shared/system-controls/session/SessionProvider';
import CaptchaReducer from "shared/captcha/state/CaptchaReducer";

export const CaptchaContext = React.createContext();

const CaptchaState = ({ children }) => {
  const initialState = {}
  const [state, dispatch] = useReducer(CaptchaReducer, initialState);
  const { asyncServiceCall } = useContext(SessionContext);

  //----------------------------------------------------------------
  const getNewCaptcha = useCallback(async (username) => {
    try {
      let res = await asyncServiceCall(Commands.API_URL_BITBITE_GET_NEW_CAPTCHA(username), {});
      dispatch({ type: 'SET_STATE_DATA', payload: { captchaData: res.captcha, captcha: undefined } });
    }
    catch (err) {
      dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
    }
  }, [asyncServiceCall])

  //----------------------------------------------------------------
  const verfiyCaptcha = useCallback(async (captcha) => {
    try {
      dispatch({ type: 'LOADING' });
      await asyncServiceCall(Commands.API_URL_BITBITE_VERIFY_CAPTCHA(captcha));
      getNewCaptcha();
    }
    catch (err) {
      dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
    }
  }, [asyncServiceCall, getNewCaptcha])


  return (
    <CaptchaContext.Provider
      value={{
        ...state,
        dispatch,
        getNewCaptcha,
        verfiyCaptcha,
      }}
    >
      {children}
    </CaptchaContext.Provider>
  )
}

export default CaptchaState;
